import type { DemoSeedProfile } from "../../hooks/useDemoSeedStatus";

export function demoSeedCounterLine(
  profile: DemoSeedProfile,
  phaseLabel: string,
): string {
  const summary = profile.summary;
  const progress = profile.progress;
  // @tested-by: tst_fe_onboarding_028
  if (summary === null) return phaseLabel;
  const counts = `${summary.emails.toLocaleString()} emails · ${summary.chats.toLocaleString()} chats · ${summary.people.toLocaleString()} people`;
  // @tested-by: tst_fe_onboarding_029
  // @invariant: indexing progress combines real checkpoint totals with the
  // backend-owned completed/total cursor; neither value is a UI constant.
  if (
    progress?.phase === "building_search_index" &&
    progress.totalItems !== null
  ) {
    return `${counts} · ${progress.completedItems.toLocaleString()} / ${progress.totalItems.toLocaleString()} records linked…`;
  }
  // @tested-by: tst_fe_onboarding_030, tst_fe_onboarding_031
  return progress?.phase === "complete"
    ? `${counts} linked`
    : `${counts} · ${phaseLabel}`;
}
